import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';

class OrganizerResource extends Resource {
  constructor() {
    super('tournaments', httpResource);
  }

  public async uploadLogo(tournamentId: number, logo: File) {
    const formData = new FormData();

    formData.append('logo', logo);
    formData.append('tournamentId', String(tournamentId));

    return await this.child('logo').post(formData);
  }
}

const organizerResource = new OrganizerResource();

export default organizerResource;
